export const BRAND = {
  name: "El Monos",
  fullName: "El Monos Landscaping & Junk Removal LLC",
  phone: "210-900-6542",
  phoneRaw: "2109006542",
  email: "elmonoslandscaping@gmail.com",
  city: "San Antonio, TX",
  hours: "Mon–Sat · 7:00 AM – 8:00 PM",
  yearsExperience: 25,
};

/**
 * Real client job photos.
 *
 * jobFront    — stunning after shot: fresh black mulch, palms, boxwoods
 * jobSide     — side-yard transformation with fresh mulch & new sod
 * jobBackyard — mowed back yard with patio & shed
 * jobLot      — rural lawn/lot after mow
 * jobSod      — mid-job: laying sod along newly prepped bed
 */
export const IMAGES = {
  hero:
    "https://customer-assets-agu9un31.emergentagent.net/job_pickup-kings/artifacts/7a3b0ecb067a6c8e_2.webp",
  jobFront:
    "https://customer-assets-agu9un31.emergentagent.net/job_pickup-kings/artifacts/6ad5bfcf2dd83c5a_5.webp",
  jobSide:
    "https://customer-assets-agu9un31.emergentagent.net/job_pickup-kings/artifacts/9ac08341156bc2f5_4.webp",
  jobBackyard:
    "https://customer-assets-agu9un31.emergentagent.net/job_pickup-kings/artifacts/37c9b07ef3880eca_2.webp",
  jobLot:
    "https://customer-assets-agu9un31.emergentagent.net/job_pickup-kings/artifacts/76d6990caf557f51_3.webp",
  jobSod:
    "https://customer-assets-agu9un31.emergentagent.net/job_pickup-kings/artifacts/a927cb11f9edb6f4_1.webp",
};
